export default __webpack_public_path__ + "static/media/12-bottom.e122e715.png";